import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import { analytics } from 'core/analytics';
import { Link } from 'core/routing';

import { Tag, TagsTitle, Indicator } from 'legacyComponents/styled/lib';
import { modalStore } from 'apps/modals/app';
import { clientStore } from 'apps/client/app';

import { EditTagsForm } from 'apps/tag/views/editTagsForm';
import { InitiativeApp } from 'apps/initiative/app';

// FIXME If we remove this it will break the modal
/* eslint-disable no-unused-vars */
import { TagAutoComplete } from 'apps/tag/views/autocomplete'; // import hack
import { TagItem } from 'apps/tag/views/item'; // import hack
import { TagsFieldStore } from 'apps/tag/fieldStores'; // import hack

import Icon from 'components/Icon';
import Button from 'components/Button';

import styled from 'styled-components';
import { TagsMainWrapper, TagsWrapper } from 'apps/tag/styles';
import { media } from 'legacyComponents/styled/styleUtils';

export const Tags = withNamespaces()(
  observer(props => {
    const { type, app, mobileCentered, t } = props;
    const { editing } = app;
    const propTags = props.tags;
    const { deletedCount, isEmpty } = propTags;

    const clickAddTags = () => {
      app.EditTags();
      modalStore.SetModalComponent(EditTagsForm, { app, small: true });
    };

    const tagsListOutput = propTags
      .filter(tag => !tag?.deleted)
      .map((tag, index) => {
        if (editing) {
          return (
            <Tag profile='true' key={tag.name} marginBottom>
              #{tag.name}
              <IconStyled
                name='close'
                size='8px'
                onClick={() => propTags.Delete(tag)}
              />
            </Tag>
          );
        }
        return (
          <Link name='channel' params={{ channel: tag.name }} key={tag.name}>
            <Tag
              onClick={() => {
                analytics.sendEvent('clicked-tag', { name: tag.name });
              }}
              profile='true'
              last={index === 2}
            >
              #{tag.name}
            </Tag>
          </Link>
        );
      });

    const canBeHidden =
      type === 'Project'
        ? false
        : type === 'Skills'
        ? true
        : app instanceof InitiativeApp;

    return (
      <TagsMainWrapper
        canBeHidden={canBeHidden}
        float={props.float}
        centered={
          mobileCentered && ['s', 'xs'].includes(clientStore.activeBreakPoint)
        }
      >
        {type === 'Skills' ? (
          <TagsTitle hidden={propTags.length === 0 && !editing}>
            {`${t(type)}:`}
          </TagsTitle>
        ) : editing && type !== 'Project' ? (
          <TagsTitle hidden={!editing}>{`${type}:`}</TagsTitle>
        ) : null}
        {tagsListOutput.length !== 0 && (
          <TagsWrapper>{tagsListOutput}</TagsWrapper>
        )}
        {editing && propTags.length - deletedCount < 3 && (
          <Button
            text={isEmpty ? `Add ${type}` : ''}
            iconPosition='right'
            variant='secondary'
            size='xsmall'
            icon='add'
            outline
            onClick={clickAddTags}
            style={{ display: 'inlineBlock' }}
          />
        )}
      </TagsMainWrapper>
    );
  }),
);

Tags.defaultProps = {
  type: 'Topics',
};

Tags.propTypes = {
  type: PropTypes.string,
  tags: PropTypes.object,
  float: PropTypes.string,
  app: PropTypes.object,
  t: PropTypes.func,
};

const IconStyled = styled(Icon)`
  margin-left: 10px;
  vertical-align: baseline;
  color: ${props => props.theme.color.wfOrange};
  &:hover {
    transform: scale(1.3);
  }
`;

export const TagIndicator = styled(Indicator)`
  width: 70px;
  height: 22px;
  margin-right: 18px;
  display: inline-block;
  ${media.s`
    display: none;
  `}
`;

export const TagsIndicator = () => {
  return (
    <TagsMainWrapper>
      <TagIndicator />
      <TagIndicator />
      <TagIndicator />
    </TagsMainWrapper>
  );
};
